import React, { Component } from 'react'
import { Button } from 'semantic-ui-react'
// import uploadcare from 'uploadcare-widget'

class ImageFieldContainer extends Component {
  // componentDidMount() {
  //   let {onChange, name} = this.props

  //   const widget = uploadcare.Widget(this.uploader)

  //   widget.onChange((file) => {
  //     if (file) {
  //       file
  //         .done(info => onChange({name, value: info.cdnUrl}))
  //         .fail(() => onChange({name, value: false}))
  //     } else {
  //       onChange({name, value: false})
  //     }
  //   })
  // }

  render() {
    let { name, value, defaultImage } = this.props
    if (!value && defaultImage) value = defaultImage
    return (
      <div className="form-field-image">
        {value ? (
          <div className="form-field-image-preview">
            <img src={value} />
          </div>
        ) : null}
        <input type="hidden" ref={el => (this.uploader = el)} id={`image-${name}`} name={name} />
      </div>
    )
  }
}

export default ImageFieldContainer
